import React from 'react';
import { Stack, xcss } from '@atlaskit/primitives';
import { RecommendationItem } from './recommendation-item';
var listStyles = xcss({
  paddingInlineStart: 'space.0'
});
export var RecommendationList = function RecommendationList(props) {
  var recommendations = props.recommendations,
    _onApply = props.onApply,
    _onDismiss = props.onDismiss;
  return /*#__PURE__*/React.createElement(Stack, {
    as: "ul",
    xcss: listStyles
  }, recommendations === null || recommendations === void 0 ? void 0 : recommendations.map(function (r) {
    return /*#__PURE__*/React.createElement(RecommendationItem, {
      key: r.id,
      id: r.id,
      action: r.transformAction,
      onApply: function onApply() {
        return _onApply({
          recommendation: r
        });
      },
      onDismiss: function onDismiss() {
        return _onDismiss({
          recommendation: r
        });
      }
    });
  }));
};